import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { DocumentTemplateMutations } from "@/store/modules/documentTemplate/mutations";
import { IDocumentTemplateState } from "@/store/modules/documentTemplate/state";

export enum DocumentTemplateActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_DOCUMENT_TEMPLATE",
  FETCH_ONE = "FETCH_ONE_DOCUMENT_TEMPLATE",
  CREATE = "CREATE_DOCUMENT_TEMPLATE",
  UPDATE = "UPDATE_DOCUMENT_TEMPLATE",
  DELETE = "DELETE_DOCUMENT_TEMPLATE",
  DELETE_ALL = "SET_ALL_DOCUMENT_TEMPLATE",
}

export const actions: ActionTree<IDocumentTemplateState, IRootState> = {
  async [DocumentTemplateActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/documents/document-template/list", {
        params: params,
      });
      commit(DocumentTemplateMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("get document template data provider error: ", error);
    }
  },
  async [DocumentTemplateActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(
        `/documents/document-template/view/${id}`
      );
      commit(DocumentTemplateMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch document template one error: ", error);
    }
  },
  async [DocumentTemplateActions.CREATE]({ commit }, data: Document) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/documents/document-template/create", data)
        .then((data) => {
          commit(DocumentTemplateMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("document template create error: ", error);
          reject(error.response);
        });
    });
  },
  async [DocumentTemplateActions.UPDATE]({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(`/documents/document-template/update/${id}`, data)
        .then((data) => {
          commit(DocumentTemplateMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("document template update error: ", error);
          reject(error.response);
        });
    });
  },
  async [DocumentTemplateActions.DELETE](
    { commit },
    payload: string | { id: string; coordinatorId?: string }
  ) {
    const id = typeof payload === "string" ? payload : payload.id;
    const coordinatorId =
      typeof payload === "object" ? payload.coordinatorId : undefined;
    try {
      await baseApi.delete(`/documents/document-template/delete/${id}`, {
        params: coordinatorId != null ? { coordinatorId } : undefined,
      });
    } catch (error) {
      console.log("document template delete error:", error);
      throw error;
    }
  },
  async [DocumentTemplateActions.DELETE_ALL]({ commit }) {
    try {
      await baseApi.delete(`/documents/document-template`);
      commit(DocumentTemplateMutations.SET_ALL, []);
    } catch (error) {
      console.log("document template delete all", error);
    }
  },
};
